import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import {BASE} from '../api/api'
import Axios from 'axios'
import cachios from 'cachios'
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import { List } from 'react-content-loader'
import grey from '../assets/grey.jpg'

class InstitutionMore extends Component {
    constructor(props) {
        super(props);
        this.state={
            news:'',
            img_source:'',
            limit:15,
            offset:0,
            next:false,
            prev:false,
            type:props.match.params.id,
            loginred:'/login?redir='+props.location.pathname

        }
      }
    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
      //Next/previous click function
    handlePageClick = data => {
      console.log(data,'offset')
       
      if(data==='next'&&this.state.next===true){
        this.setState({
          news:'',
      })
        this.apicall(this.state.offset+this.state.limit)
        this.setState({
          offset:this.state.offset+this.state.limit
      })
      }
      else if(data==='prev'&&this.state.prev===true){
        this.setState({
          news:'',
      })
        this.setState({
          offset:this.state.offset-this.state.limit
      })
      this.apicall(this.state.offset-this.state.limit)
      }
    
    
  };

  checklogin(){
    let dt = localStorage.getItem('token')
    if (!dt || dt == null) {
      window.location.href = this.state.loginred
    }
    else
      return true

  }


  componentWillMount(){
    if(this.checklogin){
      this.apicall(0);
    }
    this.topFunction();
}

        apicall(id)
    
        {
          
          this.topFunction();

         //HIDE/SHOW  previous button
         if(id<=0){
             this.setState({
                 prev:false,
             })
         }
         else{
             this.setState({
                 prev:true
             })
         }
       
    Axios(BASE+'jsonapi/node/institutions?filter[titleFilter][condition][path]=field_institution_type.name&filter[titleFilter][condition][value]='+this.state.type+'&page[limit]='+this.state.limit+'&page[offset]='+(id+this.state.limit), {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
            }
        })
        .then((data) => {   
        console.log(data.data,'next')
        //HIDE/SHOW  NEXT button
        if(data.data.data.length===0){
            this.setState({
                next:false,
            })
        }
        else{
            this.setState({
                next:true
            })
        }
        })
    
      cachios.get(BASE+'jsonapi/node/institutions?filter[titleFilter][condition][path]=field_institution_type.name&filter[titleFilter][condition][value]='+this.state.type+'&page[limit]='+this.state.limit+'&page[offset]='+id, {
        ttl: 500 /* seconds */,
        })
        .then((data) => {
          let i,j;
          let logoarray=[]
            this.setState({
                news:data.data.data,
            })
        })
        .catch((err) => {
            console.log('not found')
        })
    }
render() {


    
    return (
        <div className="instmore">
        <Header/>
        <div className="page-title">
      <div className="title-wrapper">
        <div className="container">
          <h1 className="page-header">{this.state.type}</h1>
        </div>
      </div>
    </div>
        <div className="main-content listing">
      <div className="container newsrea">
        <div className="row">
          <div className="region region-content">
            <div className="listings">

                {this.state.news?this.state.news.map((news,index)=>{
                    return(
                    <div className="title">
                        <span className="field-content">
                            <Link to={{ pathname: '/financial_institution/'+this.state.type+'/' + `${news.attributes.drupal_internal__nid}`, state: {inst:news} }}>
                                {news.attributes.title}
                            </Link>
                        </span>
                    </div>
                    )
                }):<List/>
                }
            </div>
          </div>
        </div>
      </div>
    </div>
    {this.state.news&&(this.state.prev||this.state.next)?
    
    <ul className="pagination">
    <li  onClick={()=>this.handlePageClick('prev')} className="previous disabled">
    <a style={{color:this.state.prev?'#165E84 ':'',fontWeight:this.state.prev?'500':'',cursor:this.state.prev?'':'not-allowed'}} tabindex="0" role="button" className="prev" aria-disabled="true">Previous</a></li>
        <li  onClick={()=>this.handlePageClick('next')} className="next"><a style={{color:this.state.next?'#165E84 ':'',fontWeight:this.state.next?'500':'',cursor:this.state.next?'':'not-allowed'}} tabindex="0" role="button" aria-disabled="false">Next</a></li>
        
        </ul>
    
    :''}
    
            <div><Footer/></div>
            </div>
            )
    
    
}

}


export default InstitutionMore;
